import styled from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.colors.clearGray};
    background: ${props => props.theme.colors.white};
    margin-right: 10px;
    gap: 8px;
`;

export const CardHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const CardFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
`;

export const CardTitle = styled.div`
    ${props => props.theme.fonts.variant.bold()};
    font-size: 20px;
    font-style: normal;
    line-height: normal;
    flex: 1;
    color: ${props => props.theme.colors.blueOne};
    cursor: pointer;
    
    &:hover {
        opacity: 0.8;
    }
`;

export const CardActions = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const CardBody = styled.div`
    ${props => props.theme.fonts.variant.regular()};
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    color: ${props => props.theme.colors.darkGray};
    max-height: 34px;
    text-overflow: ellipsis;
    height: 34px;
`;

export const CardId = styled.span`
    ${props => props.theme.fonts.variant.semiBold()};
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    color: ${props => props.theme.colors.blueOne};
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
`;

export const CardFooterItem = styled.div`
    ${props => props.theme.fonts.variant.regular()};
    color: ${props => props.theme.colors.darkGray};
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    
    span {
        ${props => props.theme.fonts.variant.semiBold()};
        color: ${props => props.theme.colors.blueOne};
        margin-right: 8px;
    }
`;
